
<kt-portlet>
    <!--   <kt-portlet-header title="Test Alani"></kt-portlet-header> -->
    <kt-portlet-body>

        <div class="kt-section">
            <div class="kt-section__content">

                <button (click)="loadIframe()">Iframe Yükle</button>
                <div class="row justify-content-lg-center">

                   
<br><br>
<!-- <iframe #myIframe *ngIf="iframeSrc" [src]="iframeSrc" width="800" height="600"></iframe> -->
<iframe  #myIframe  [src]="sanitiser.bypassSecurityTrustResourceUrl(iframeSrc)"  [height]="600" width="100%"></iframe>

                   
                </div>

            </div>
        </div>



    </kt-portlet-body>
</kt-portlet>
